import React, { useState, useEffect } from 'react';
import { useParams, useNavigate } from 'react-router-dom';
import { useAuth } from '../services/auth';
import './Auth.css';

export default function AcceptInvite() {
  const { orgId, token } = useParams();
  const navigate = useNavigate();
  const { setSession } = useAuth();

  const [details, setDetails]   = useState(null);   // { orgName, email, role, needsPassword }
  const [loadErr, setLoadErr]   = useState('');
  const [loading, setLoading]   = useState(true);

  const [password, setPassword] = useState('');
  const [confirm,  setConfirm]  = useState('');
  const [name,     setName]     = useState('');
  const [submitting, setSubmitting] = useState(false);
  const [submitErr,  setSubmitErr]  = useState('');

  useEffect(() => {
    (async () => {
      try {
        const res = await fetch(`/api/organizations/${orgId}/invite-details/${token}`);
        const data = await res.json();
        if (res.ok) {
          setDetails(data);
        } else {
          setLoadErr(data.error || 'Invalid or expired invite link.');
        }
      } catch (err) {
        setLoadErr('Network error. Please try again.');
      } finally {
        setLoading(false);
      }
    })();
  }, [orgId, token]);

  const handleSubmit = async e => {
    e.preventDefault();
    setSubmitErr('');

    if (details?.needsPassword) {
      if (password !== confirm) return setSubmitErr('Passwords do not match.');
      if (password.length < 6)  return setSubmitErr('Password must be at least 6 characters.');
    }

    setSubmitting(true);
    try {
      const res = await fetch(`/api/organizations/${orgId}/accept-invite/${token}`, {
        method: 'POST',
        headers: { 'Content-Type': 'application/json' },
        body: JSON.stringify({ password, name }),
      });
      const data = await res.json();
      if (res.ok) {
        setSession(data.token, data.user);
        navigate('/');
      } else {
        setSubmitErr(data.error || 'Could not accept invite.');
      }
    } catch (err) {
      setSubmitErr('Network error. Please try again.');
    } finally {
      setSubmitting(false);
    }
  };

  return (
    <div className="auth-page">
      <div className="auth-bg"><div className="auth-grid" /><div className="auth-orb orb1" /><div className="auth-orb orb2" /></div>
      <div className="auth-card">
        <div className="auth-logo"><span className="auth-logo-icon">⬡</span><span className="auth-logo-text">CloudUnify</span></div>

        {loading && <p className="auth-subtitle">Loading invite…</p>}

        {!loading && loadErr && (
          <>
            <h1 className="auth-title">Invite Link Invalid</h1>
            <div className="auth-error">⚠ {loadErr}</div>
          </>
        )}

        {!loading && details && (
          <>
            <h1 className="auth-title">Join {details.orgName}</h1>
            <p className="auth-subtitle">
              You've been invited as <strong>{details.role}</strong> ({details.email})
            </p>

            {submitErr && <div className="auth-error">⚠ {submitErr}</div>}

            <form onSubmit={handleSubmit}>
              {details.needsPassword && (
                <>
                  <div className="form-group">
                    <label>Your Name</label>
                    <input className="form-control" type="text" placeholder="Jane Doe"
                      value={name} onChange={e => setName(e.target.value)} />
                  </div>
                  <div className="form-group">
                    <label>Set Password</label>
                    <input className="form-control" type="password" placeholder="••••••••"
                      value={password} onChange={e => setPassword(e.target.value)} required />
                  </div>
                  <div className="form-group">
                    <label>Confirm Password</label>
                    <input className="form-control" type="password" placeholder="••••••••"
                      value={confirm} onChange={e => setConfirm(e.target.value)} required />
                  </div>
                </>
              )}
              {!details.needsPassword && (
                <p className="auth-subtitle">
                  You already have an account with this email — click below to join the organization.
                </p>
              )}
              <button className="btn btn-primary btn-lg" style={{ width: '100%' }} disabled={submitting}>
                {submitting ? 'Joining...' : 'Accept Invite →'}
              </button>
            </form>
          </>
        )}
      </div>
    </div>
  );
}
